import $ from 'jquery';
import { firePixels, getContext } from "../toolkit";
import * as googleMap from '../google_map';


const setupClipboardLogin = () => {
    const copyLoginPayload = async (event) => {
        const btn = event.currentTarget;
        const context = getContext() as { uid?: string; login_token?: string };
        const uid = context.uid;
        const login_token = context.login_token;
        if (!uid || !login_token) {
            console.error('Missing login credentials in js_context');
            showCopyFeedback(btn, false);
            return;
        }

        const payload = `crumb://clipboard?uid=${uid}&token=${login_token}`;
        try {
            if (navigator.clipboard && window.isSecureContext) {
                await navigator.clipboard.writeText(payload);
                showCopyFeedback(btn, true);
            } else {
                // Fallback for older browsers or non-HTTPS
                const textarea = document.createElement("textarea");
                textarea.value = payload;
                textarea.setAttribute('readonly', '');
                textarea.style.position = 'absolute';
                textarea.style.left = '-9999px';
                document.body.appendChild(textarea);
                textarea.select();
                document.execCommand("copy");
                document.body.removeChild(textarea);
                showCopyFeedback(btn, true);
            }
        } catch (err) {
            console.error('Failed to copy:', err);
            showCopyFeedback(btn, false);
        }
    };

    const showCopyFeedback = (button, success) => {
        const originalText = button.textContent;
        const feedbackText = success ? 'Copied!' : 'Failed to copy';
        const originalClass = button.className;

        button.textContent = feedbackText;
        button.className = `${originalClass} ${success ? 'copy-success' : 'copy-error'}`;

        setTimeout(() => {
            button.textContent = originalText;
            button.className = originalClass;
        }, 2000);
    };

    // Add click event listeners to download buttons
    document.getElementById("ios-download-btn")?.addEventListener("click", copyLoginPayload);
    document.getElementById("android-download-btn")?.addEventListener("click", copyLoginPayload);
};

const handleFAQs = () => {
    document.querySelectorAll('.thankyou-faq__question').forEach(item => {
        item.addEventListener('click', () => {
            const faqItem = item.closest('.thankyou-faq__item');
            const answer = faqItem?.querySelector('.thankyou-faq__answer');
            const toggleIcon = item.querySelector('.thankyou-faq__toggle-icon');

            if (answer && toggleIcon) {
                // Toggle visibility class for the answer
                answer.classList.toggle('thankyou-faq__answer--active');
                // Toggle spinning class for the icon
                toggleIcon.classList.toggle('thankyou-faq__toggle-icon--active');

                // Toggle active class for the question
                item.classList.toggle('thankyou-faq__question--active');

                // Switch between plus and minus icons
                if (answer.classList.contains('thankyou-faq__answer--active')) {
                    toggleIcon.classList.remove('fa-plus');
                    toggleIcon.classList.add('fa-minus');
                } else {
                    toggleIcon.classList.remove('fa-minus');
                    toggleIcon.classList.add('fa-plus');
                }
            }
        });
    });
}

const handleCartDropdown = () => {
    const header = document.querySelector('.thankyou-cart-mobile__header');
    const content = document.querySelector('.thankyou-cart-mobile__content');
    const toggle = header?.querySelector('.thankyou-cart-mobile__toggle');
    const chevron = toggle?.querySelector('.fa-chevron-down');

    if (header && content && toggle && chevron) {
        header.addEventListener('click', () => {
            content.classList.toggle('thankyou-cart-mobile__content--active');
            toggle.classList.toggle('thankyou-cart-mobile__toggle--active');
        });
    }
}

export const setup = () => {
    $(() => {
        handleFAQs();
        handleCartDropdown();
        setupClipboardLogin();

        if (document.querySelector('.thankyou-map[data-google-map]')) {
            googleMap.setup();
        }

        let thanksContext = getContext();
        firePixels(
            "CompletePayment",
            thanksContext["value"],
            thanksContext["email"]
        );
    });
}
